module.exports = __webpack_public_path__ + "static/media/ilhascaiman.5985bb16.jpg";